import {IFeatureParams, IFlagFeature, IToggleContainer} from '@cemex-core/cmx-rollout-toggle-v1';
import {Injectable} from '@angular/core';
import {Features} from '../models/features.enum';
@Injectable()
export class EnableLargeOrderFeature implements IFlagFeature {
    name = Features.EnableOrderAvailabilityExpirationTime;
    isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
      return container[this.name].isEnabled();
    }
}
